import { cloudinaryService } from "services/Services";

 export const toBase64 = (file: Blob) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
    })

   export function fromBase64(base64String: string, fileName: string): File {
        const arr = base64String.split(',');
        const mimeMatch = arr[0].match(/:(.*?);/);
        const mime = mimeMatch ? mimeMatch[1] : '';
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], fileName, { type: mime });
    }

    export async function urlToFile(url: string, filename: string, mimeType: string): Promise<File> {
        const response = await fetch(url);
        const blob = await response.blob();
        return new File([blob], filename, { type: mimeType });
    }


    
export function addCloudinaryTransformation(url:string, transformation:string) {
  const uploadSegment = '/upload/';
  const index = url.indexOf(uploadSegment);

  if (index === -1) {
    return url;
  }

  // Insert the transformation right after '/upload/'
  const transformedUrl = url.slice(0, index + uploadSegment.length) +
                         transformation + '/' +
                         url.slice(index + uploadSegment.length);

  return transformedUrl;
}


export async function generateCloudinaryImageUrl(
  file: File,
  transformation: string = "t_www-logo_v2"
): Promise<string> {
  try {
    const base64Img = await toBase64(file);
    const response = await cloudinaryService.uploadImage(base64Img as File);
    if (response?.secure_url) {
      return addCloudinaryTransformation(response.secure_url, transformation);
    }
  } catch (error) {
    console.error("Error generating Cloudinary image URL:", error);
  }
  return "";
}

